import { IImageInfo } from "@types";
import { atom, selectorFamily, atomFamily, AtomEffect } from "recoil";
import type { resultItemType } from "../components/new/TrainingProgressDropdown";

interface aiModuleDescType {
  name: string;
  epoch?: number;
  infer: boolean;
  is_complete: boolean;
  iteration?: number;
  preview: boolean;
  total: number;
  train: boolean;
  trained_count: number;
}

export interface aiModuleType {
  uuid: string;
  serverAddress: string;
  desc: aiModuleDescType;
  options: any;
}

export const myAIModuleState = atom<aiModuleType | null>({
  key: "myAIModuleKey",
  default: null,
});

export const trainUuidState = atom<string | null>({
  key: "trainUuidKey",
  default: null,
});

export const inspModelUuidState = atom<string | null>({
  key: "inspModelUuidKey",
  default: null,
});

export const trainingStateAtom = atom<Record<string, boolean>>({
  key: "trainingStateKey",
  default: {},
});

export const validatingStateAtom = atom<Record<number, boolean>>({
  key: "validatingStateKey",
  default: {},
});

export const validListStateAtom = atom<Record<number, IImageInfo[]>>({
  key: "validListStateKey",
  default: {},
});

// 진행 중인 epoch 학습의 에폭별 결과 (저장된 모델 uuid 포함) — 학습 중 히트맵이 쓸 최신 모델을 여기서 찾는다
export const epochResultsState = atom<resultItemType[]>({
  key: "epochResultsKey",
  default: [],
});

// 히트맵을 뽑는 모델
export interface HeatmapModelRef {
  uuid: string;
  label: string; // 화면 상단에 보여줄 이름
  source: "insp" | "epoch";
  modelId?: number;
  auto?: boolean;
}

export const heatmapModelState = atom<HeatmapModelRef | null>({
  key: "heatmapModelKey",
  default: null,
});

// 위 모델을 올려둔 AI 서버 모듈. 히트맵(ImagePart)과 스냅샷(TrainSnapshot)이 같이 쓴다
export const heatmapModuleState = atom<any | null>({
  key: "heatmapModuleKey",
  default: null,
});

export const heatmapModuleMsgState = atom<string | null>({
  key: "heatmapModuleMsgKey",
  default: null,
});

export const heatmapModuleUsersState = atom<number>({
  key: "heatmapModuleUsersKey",
  default: 0,
});

export const imageDataState = atom<any | null>({
  key: "imageDataKey",
  default: null,
});

export const processImageSrcState = atom<any | null>({
  key: "processImageSrcKey",
  default: null,
});

export const scoreMapImageState = atom<any | null>({
  key: "scoreMapImageKey",
  default: null,
});

// both는 원본과 scoremap 동시에
export const imageViewModeState = atom<"original" | "preview" | "scoremap">({
  key: "imageViewModelKey",
  default: "original",
});

interface epochItem {
  current: number;
  total: number;
  num_train: number; //누적 이미지 수
}

export const continueTrainInfoState = atom<{
  id: number | null;
  uuid: string | null;
  trainHistory_id: number | null;
  validHistory_id: number | null;
  epoch: epochItem;
}>({
  key: "continueTrainInfoState",
  default: {
    id: null,
    uuid: null,
    trainHistory_id: null,
    validHistory_id: null,
    epoch: {
      current: 0,
      total: 0,
      num_train: 0,
    },
  },
});

// 비교 이미지 담기 목록
export interface CompareImage {
  path: string;
  label?: string;
  score?: number;
}

const compareBasketStorage =
  (key: string): AtomEffect<CompareImage[]> =>
  ({ setSelf, onSet }) => {
    try {
      const saved = localStorage.getItem(key);
      if (saved) setSelf(JSON.parse(saved));
    } catch {}
    onSet((items) => {
      try {
        localStorage.setItem(key, JSON.stringify(items));
      } catch {}
    });
  };
export const compareBasketState = atomFamily<CompareImage[], string>({
  key: "compareBasketState",
  default: [],
  effects: (projectId) => [compareBasketStorage(`compareBasket:${projectId}`)],
});

export const openHistogramPopState = atom<boolean>({
  key: "openHistogramPopState",
  default: false,
});
